var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb cmp-product-thumb--grid",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { staticClass: "article-inner" },
        [
          _c(
            "div",
            { staticClass: "article-inner-image" },
            [
              _vm.item.variation.availability.id == 5 &&
              (_vm.stoffparent == null ||
                _vm.stoffparent != "parent" ||
                (_vm.item.variation.minimumOrderQuantity > _vm.item.stock.net &&
                  _vm.stoffparent != "parent")) &&
              _vm.item.item.stockLimitation != 1
                ? [
                    _c("div", { staticClass: "special-tags" }, [
                      _c(
                        "span",
                        { staticClass: "badge badge-offer badge-danger" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$translate(
                                  "Snaply5::Template.catAusverkauft"
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    ])
                  ]
                : [
                    _vm.item.item.storeSpecial != null
                      ? [
                          _vm.showrrp || _vm.item.item.storeSpecial.id == 1
                            ? [
                                _vm.item.prices.rrp.price.value >
                                _vm.item.prices.default.price.value
                                  ? [
                                      _vm.item.prices.rrp.price.value >
                                      _vm.item.prices.default.price.value
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "special-tags" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-offer badge-info"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                       " +
                                                        _vm._s(
                                                          _vm.percentFixed
                                                        ) +
                                                        " %\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              { staticClass: "special-tags" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-offer badge-info"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Snaply5::Template.catAngebot"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                    ]
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.item.item.storeSpecial.id == 2
                            ? [
                                _c("div", { staticClass: "special-tags" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-offer badge-info"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Snaply5::Template.catNew"
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.item.item.storeSpecial.id == 3
                            ? [
                                _c("div", { staticClass: "special-tags" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-offer badge-info"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Snaply5::Template.catTop"
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: _vm._f("clickable")(_vm.item),
                    alt: _vm._f("itemName")(_vm.item),
                    title: _vm._f("itemName")(_vm.item)
                  }
                },
                [
                  _vm.showVariationImagePossible
                    ? [
                        _vm.item.images.all.length > 1 && _vm.showSecondImage
                          ? [
                              _vm.endless
                                ? [
                                    _c("img", {
                                      staticClass: "img-fluid owl-lazy",
                                      attrs: {
                                        "data-src":
                                          _vm.item.images.all[1]
                                            .urlSecondPreview
                                      }
                                    })
                                  ]
                                : [
                                    _c("lazy-img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        "image-url":
                                          _vm.item.images.all[1]
                                            .urlSecondPreview,
                                        alt: _vm._f("itemName")(_vm.item),
                                        title: _vm._f("itemName")(_vm.item)
                                      }
                                    })
                                  ]
                            ]
                          : [
                              _vm.endless
                                ? [
                                    _vm.item.images.variation.length > 0
                                      ? [
                                          _c("img", {
                                            staticClass: "img-fluid owl-lazy",
                                            attrs: {
                                              "data-src":
                                                _vm.item.images.variation[0]
                                                  .urlSecondPreview
                                            }
                                          })
                                        ]
                                      : [
                                          _c("img", {
                                            staticClass: "img-fluid owl-lazy",
                                            attrs: {
                                              "data-src":
                                                _vm.item.images.all[0]
                                                  .urlSecondPreview
                                            }
                                          })
                                        ]
                                  ]
                                : [
                                    _vm.item.images.variation.length > 0
                                      ? [
                                          _c("lazy-img", {
                                            staticClass: "img-fluid",
                                            attrs: {
                                              "image-url":
                                                _vm.item.images.variation[0]
                                                  .urlSecondPreview,
                                              alt: _vm._f("itemName")(_vm.item),
                                              title: _vm._f("itemName")(
                                                _vm.item
                                              )
                                            }
                                          })
                                        ]
                                      : [
                                          _c("lazy-img", {
                                            staticClass: "img-fluid",
                                            attrs: {
                                              "image-url":
                                                _vm.item.images.all[0]
                                                  .urlSecondPreview,
                                              alt: _vm._f("itemName")(_vm.item),
                                              title: _vm._f("itemName")(
                                                _vm.item
                                              )
                                            }
                                          })
                                        ]
                                  ]
                            ]
                      ]
                    : [
                        _vm.endless
                          ? [
                              _vm.item.images.variation.length > 0
                                ? [
                                    _c("img", {
                                      staticClass: "img-fluid owl-lazy",
                                      attrs: {
                                        "data-src":
                                          _vm.item.images.variation[0]
                                            .urlSecondPreview
                                      }
                                    })
                                  ]
                                : [
                                    _c("img", {
                                      staticClass: "img-fluid owl-lazy",
                                      attrs: {
                                        "data-src":
                                          _vm.item.images.all[0]
                                            .urlSecondPreview
                                      }
                                    })
                                  ]
                            ]
                          : [
                              _vm.item.images.variation.length > 0
                                ? [
                                    _c("lazy-img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        "image-url":
                                          _vm.item.images.variation[0]
                                            .urlSecondPreview,
                                        alt: _vm._f("itemName")(_vm.item),
                                        title: _vm._f("itemName")(_vm.item)
                                      }
                                    })
                                  ]
                                : [
                                    _c("lazy-img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        "image-url":
                                          _vm.item.images.all[0]
                                            .urlSecondPreview,
                                        alt: _vm._f("itemName")(_vm.item),
                                        title: _vm._f("itemName")(_vm.item)
                                      }
                                    })
                                  ]
                            ]
                      ],
                  _vm._v(" "),
                  _vm.showproducer != null
                    ? [
                        _c("span", { staticClass: "producer" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$translate("Snaply5::Template.singleAuthor")
                              ) +
                              " " +
                              _vm._s(_vm.showproducer) +
                              "\n                    "
                          )
                        ])
                      ]
                    : [
                        _vm.countvars > 0
                          ? [
                              _c("span", { staticClass: "producer" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.countvars) +
                                    "  " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Snaply5::Template.catVariations"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ])
                            ]
                          : _vm.countvars <= 1 && _vm.stoffparent == "parent"
                          ? [
                              _c("span", { staticClass: "producer" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Snaply5::Template.catManyColors"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ])
                            ]
                          : _vm._e()
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _vm.item.prices.default.price.value != 0 && !_vm.item.item.free1
                ? [
                    _c("csaddtolist", {
                      attrs: {
                        "variation-id": _vm.item.variation.id,
                        "single-item": false
                      }
                    })
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "before-prices slot" },
            [_vm._t("before-prices")],
            2
          ),
          _vm._v(" "),
          _vm._t("item-details", [
            _c(
              "div",
              { staticClass: "article-inner-always" },
              [
                _vm.item.prices.default.price.value != 0 || _vm.ParentPrice != 0
                  ? [
                      _c(
                        "div",
                        { staticClass: "d-flex split" },
                        [
                          _vm.calcWidth() > 0 && _vm.pid == 22413
                            ? _c(
                                "div",
                                { staticClass: "category-feedback d-flex" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "feedback-stars-average feedback-category-view"
                                    },
                                    [
                                      _vm._m(0),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "feedback-stars-overlay-wrap",
                                          style:
                                            "width:" + _vm.calcWidth() + "%"
                                        },
                                        [_vm._m(1)]
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                      (" +
                                      _vm._s(_vm.item.item.feedbackCount) +
                                      ")\n                    "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.ParentPrice != 0
                            ? [
                                _c("div", { staticClass: "prices" }, [
                                  _c("div", { staticClass: "price" }, [
                                    _c(
                                      "span",
                                      { staticClass: "price-n" },
                                      [
                                        _vm.ParentPrice > 0
                                          ? [
                                              _vm._v(
                                                "\n                                      " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      _vm.ParentPrice
                                                    )
                                                  ) +
                                                  "\n                                  "
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                ])
                              ]
                            : [
                                _vm.item.variation.intervalOrderQuantity
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "price" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "price-n",
                                              class: { red: _vm.showrrp }
                                            },
                                            [
                                              _vm.item.prices.default.price
                                                .value *
                                                _vm.item.variation
                                                  .minimumOrderQuantity >
                                              0
                                                ? [
                                                    _vm.item.variation
                                                      .minimumOrderQuantity ==
                                                    0.1
                                                      ? [
                                                          _vm._v(
                                                            "\n                                        " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currency"
                                                                )(
                                                                  _vm.item
                                                                    .prices
                                                                    .default
                                                                    .price
                                                                    .value *
                                                                    (_vm.item
                                                                      .variation
                                                                      .minimumOrderQuantity *
                                                                      5)
                                                                )
                                                              ) +
                                                              "\n                                      "
                                                          )
                                                        ]
                                                      : [
                                                          _vm._v(
                                                            "\n                                        " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currency"
                                                                )(
                                                                  _vm.item
                                                                    .prices
                                                                    .default
                                                                    .price
                                                                    .value *
                                                                    _vm.item
                                                                      .variation
                                                                      .minimumOrderQuantity
                                                                )
                                                              ) +
                                                              "\n                                      "
                                                          )
                                                        ]
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _vm.showrrp
                                            ? [
                                                _c(
                                                  "span",
                                                  { staticClass: "rrp" },
                                                  [
                                                    _vm.item.prices.rrp.price
                                                      .value *
                                                      _vm.item.variation
                                                        .minimumOrderQuantity >
                                                    0
                                                      ? [
                                                          _vm.item.variation
                                                            .minimumOrderQuantity ==
                                                          0.1
                                                            ? [
                                                                _vm._v(
                                                                  "\n                                            " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "currency"
                                                                      )(
                                                                        _vm.item
                                                                          .prices
                                                                          .rrp
                                                                          .price
                                                                          .value *
                                                                          (_vm
                                                                            .item
                                                                            .variation
                                                                            .minimumOrderQuantity *
                                                                            5)
                                                                      )
                                                                    ) +
                                                                    "\n                                         "
                                                                )
                                                              ]
                                                            : [
                                                                _vm._v(
                                                                  "\n                                           " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "currency"
                                                                      )(
                                                                        _vm.item
                                                                          .prices
                                                                          .rrp
                                                                          .price
                                                                          .value *
                                                                          _vm
                                                                            .item
                                                                            .variation
                                                                            .minimumOrderQuantity
                                                                      )
                                                                    ) +
                                                                    "\n                                         "
                                                                )
                                                              ]
                                                        ]
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "price-n",
                                          class: { red: _vm.showrrp }
                                        },
                                        [
                                          _vm.item.prices.default.price.value >
                                          0
                                            ? [
                                                _vm._v(
                                                  "\n                                  " +
                                                    _vm._s(
                                                      _vm.item.prices.default
                                                        .price.formatted
                                                    ) +
                                                    "\n                               "
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.showrrp
                                        ? [
                                            _c(
                                              "span",
                                              { staticClass: "rrp" },
                                              [
                                                _vm.item.prices.rrp.price
                                                  .value > 0
                                                  ? [
                                                      _vm._v(
                                                        "\n                                      " +
                                                          _vm._s(
                                                            _vm.item.prices.rrp
                                                              .price.formatted
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ]
                                        : _vm._e()
                                    ]
                              ]
                        ],
                        2
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.unit && _vm.item.unit.unitOfMeasurement == "MTR"
                  ? [
                      _c(
                        "span",
                        { staticClass: "small-info-price" },
                        [
                          _vm.item.variation.minimumOrderQuantity == 0.1
                            ? [
                                _c("span", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.replace(
                                          _vm.item.variation
                                            .minimumOrderQuantity * 5
                                        )
                                      ) +
                                      " " +
                                      _vm._s(_vm.item.unit.names.name) +
                                      " | " +
                                      _vm._s(
                                        _vm.item.prices.default.basePrice
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            : [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.item.unit.content))
                                ]),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.item.unit.names.name) +
                                    "\n                        "
                                ),
                                _vm.item.unit.content != 1
                                  ? [
                                      _vm._v(
                                        "\n                         | " +
                                          _vm._s(
                                            _vm.item.prices.default.basePrice
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  : _vm._e()
                              ]
                        ],
                        2
                      )
                    ]
                  : _vm.item.unit && _vm.ParentPrice != 0
                  ? [
                      _c(
                        "span",
                        { staticClass: "small-info-price" },
                        [
                          _vm.ParentPricehalbm2 == 0
                            ? [
                                _c("span", [
                                  _vm._v(
                                    "\n                             0,5 " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Snaply5::Template.catMeterWare"
                                        )
                                      ) +
                                      " | " +
                                      _vm._s(
                                        _vm._f("currency")(2 * _vm.ParentPrice)
                                      ) +
                                      " / " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Snaply5::Template.catMeterWare"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            : [
                                _c("span", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.replace(_vm.ParentPricehalbm2)
                                      ) +
                                      " m² | " +
                                      _vm._s(
                                        _vm.ParentPrice / _vm.ParentPricehalbm2
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Snaply5::Template.catCurrencyMeter2"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                        ],
                        2
                      )
                    ]
                  : _vm.item.prices.default.basePrice &&
                    _vm.item.prices.default.basePrice != "N / A"
                  ? [
                      _c("span", { staticClass: "small-info-price" }, [
                        _c(
                          "span",
                          [
                            _vm.item.prices.default.basePrice
                              ? [
                                  _vm.item.unit.names.unitId == 49
                                    ? [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.item.unit.content * 100
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Snaply5::Template.catMeterWare"
                                              )
                                            ) +
                                            " |  " +
                                            _vm._s(
                                              _vm.item.prices.default.basePrice
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.item.unit.content) +
                                            " " +
                                            _vm._s(_vm.item.unit.names.name) +
                                            " "
                                        ),
                                        _vm.item.prices.default.basePrice !=
                                          "" &&
                                        _vm.item.prices.default.basePrice !=
                                          "N / A"
                                          ? [
                                              _vm._v(
                                                " | " +
                                                  _vm._s(
                                                    _vm.item.prices.default
                                                      .basePrice
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          : _vm._e()
                                      ]
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "name",
                    attrs: { href: _vm._f("clickable")(_vm.item) }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("itemName")(_vm.item)) +
                        "\n                "
                    ),
                    _vm.item.attributes.length > 0 && _vm.showAttributes
                      ? [
                          _c("br"),
                          _vm._v(" "),
                          _vm._l(_vm.item.attributes, function(attr) {
                            return _c(
                              "span",
                              { key: attr.id, staticClass: "cat-attr" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [
                                    _vm._v(
                                      _vm._s(attr.attribute.names.name) + ":"
                                    )
                                  ]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(attr.value.names.name) +
                                    "\n                  "
                                )
                              ]
                            )
                          })
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ],
              2
            ),
            _vm._v(" "),
            _vm.showCart
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block btn-primary btn-danger",
                      on: {
                        click: function($event) {
                          return _vm.addVariationToBasket(_vm.item.variation.id)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$translate(
                              "Snaply5::Template.singleColorToBasket"
                            )
                          ) +
                          "\n                "
                      ),
                      _vm.dataLoading
                        ? [
                            _c("i", {
                              staticClass: "fa fa-spin fa-circle-o-notch",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        : [
                            _c("i", {
                              staticClass: "fa fa-shopping-cart",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                    ],
                    2
                  )
                ]
              : _vm._e()
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "feedback-stars-background clearfix" }, [
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "feedback-stars-overlay clearfix" }, [
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-star" }, [
        _c("i", { staticClass: "fa fa-star" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }